"use client";

import { c as _c } from "react/compiler-runtime";
import { usePersona } from "@opensea/navigation";
import { Button } from "@opensea/next-ui-kit";
import { classNames, Flex, QuantityInput, Tooltip } from "@opensea/ui-kit";
import { useFlowEventHandlers, useMintFlow } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { useShallow } from "zustand/react/shallow";
import { useDropStore } from "@/components/collection/drops/components/CollectionDropContext";
import { DropStatus } from "@/components/collection/drops/constants";
import { useAuthenticatedCallback } from "@/hooks/use-authenticated-callback";
export function MintButton(t0) {
  const $ = _c(58);
  const {
    className,
    collectionSlug,
    showQtyInput: t1,
    overrides: t2,
    size
  } = t0;
  const showQtyInput = t1 === undefined ? true : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const overrides = t3;
  const [status, is1155Drop, isEligibleForCurrentStage, maxMints, quantityMinted, setQuantityMinted] = useDropStore(useShallow(_temp));
  const {
    register,
    setValue,
    control
  } = useFormContext();
  let t4;
  if ($[2] !== control) {
    t4 = {
      control
    };
    $[2] = control;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    errors
  } = useFormState(t4);
  const t = useTranslations("MintButton");
  let t5;
  if ($[4] !== control) {
    t5 = {
      control,
      name: "quantity"
    };
    $[4] = control;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const quantity = useWatch(t5);
  let t6;
  if ($[6] !== control) {
    t6 = {
      control,
      name: "selectedTokenOptions"
    };
    $[6] = control;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const selectedTokenOptions = useWatch(t6);
  const hasMintsRemaining = maxMints === undefined || maxMints > 0;
  const shouldDisableCta = !hasMintsRemaining || isEligibleForCurrentStage === false || is1155Drop && !selectedTokenOptions?.length;
  const {
    persona
  } = usePersona();
  const mode = persona === "advanced" ? "minimized" : "full";
  let t7;
  if ($[8] !== mode) {
    t7 = {
      mode
    };
    $[8] = mode;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const startMintFlow = useMintFlow(t7);
  let t8;
  if ($[10] !== collectionSlug || $[11] !== is1155Drop || $[12] !== quantity || $[13] !== selectedTokenOptions || $[14] !== startMintFlow) {
    t8 = () => {
      const tokenInput = is1155Drop ? selectedTokenOptions?.map(_temp2) : [{
        quantity: quantity ?? 1,
        tokenId: "0"
      }];
      if (tokenInput) {
        startMintFlow(collectionSlug, tokenInput);
      }
    };
    $[10] = collectionSlug;
    $[11] = is1155Drop;
    $[12] = quantity;
    $[13] = selectedTokenOptions;
    $[14] = startMintFlow;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const openMintFlow = useAuthenticatedCallback(t8);
  let t9;
  if ($[16] !== quantity || $[17] !== quantityMinted || $[18] !== setQuantityMinted) {
    t9 = {
      onSuccess: () => {
        setQuantityMinted(quantityMinted + Number(quantity ?? 1));
      }
    };
    $[16] = quantity;
    $[17] = quantityMinted;
    $[18] = setQuantityMinted;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  useFlowEventHandlers(t9);
  let t10;
  if ($[20] !== hasMintsRemaining || $[21] !== is1155Drop || $[22] !== isEligibleForCurrentStage || $[23] !== selectedTokenOptions?.length || $[24] !== t) {
    t10 = () => {
      if (!hasMintsRemaining) {
        return t("disabledTooltip.noMintsRemaining");
      }
      if (isEligibleForCurrentStage === false) {
        return t("disabledTooltip.notEligible");
      }
      if (is1155Drop && !selectedTokenOptions?.length) {
        return t("disabledTooltip.noTokensSelected");
      }
      return "";
    };
    $[20] = hasMintsRemaining;
    $[21] = is1155Drop;
    $[22] = isEligibleForCurrentStage;
    $[23] = selectedTokenOptions?.length;
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const getDisabledTooltipContent = t10;
  if (status === DropStatus.MINTING) {
    let t11;
    if ($[26] !== className) {
      t11 = classNames("gap-4", className);
      $[26] = className;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    let t12;
    if ($[28] !== errors || $[29] !== maxMints || $[30] !== quantity || $[31] !== register || $[32] !== setValue || $[33] !== shouldDisableCta || $[34] !== showQtyInput || $[35] !== size) {
      t12 = showQtyInput ? <QuantityInput disabled={shouldDisableCta} onValueChange={v => setValue("quantity", v)} size={size} value={quantity} {...register("quantity", {
        valueAsNumber: true,
        validate: {
          isNumber: _temp3,
          isBetweenOneAndMax: v_1 => !Number.isNaN(v_1) && v_1 !== undefined && v_1 !== null && v_1 >= 1 && maxMints !== undefined && v_1 <= maxMints || `Quantity must be between 1 and ${String(maxMints)}`
        },
        onBlur() {
          if (quantity !== null && maxMints !== undefined && quantity > maxMints) {
            setValue("quantity", maxMints);
          }
        }
      })} error={Boolean(errors.quantity)} max={maxMints} min={1} /> : null;
      $[28] = errors;
      $[29] = maxMints;
      $[30] = quantity;
      $[31] = register;
      $[32] = setValue;
      $[33] = shouldDisableCta;
      $[34] = showQtyInput;
      $[35] = size;
      $[36] = t12;
    } else {
      t12 = $[36];
    }
    let t13;
    if ($[37] !== getDisabledTooltipContent) {
      t13 = getDisabledTooltipContent();
      $[37] = getDisabledTooltipContent;
      $[38] = t13;
    } else {
      t13 = $[38];
    }
    const t14 = !shouldDisableCta;
    const t15 = !quantity || Boolean(errors.quantity) || shouldDisableCta;
    const t16 = overrides.Button;
    let t17;
    if ($[39] !== t) {
      t17 = t("mint");
      $[39] = t;
      $[40] = t17;
    } else {
      t17 = $[40];
    }
    let t18;
    if ($[41] !== openMintFlow || $[42] !== overrides.Button || $[43] !== size || $[44] !== t15 || $[45] !== t17) {
      t18 = <Button disabled={t15} onClick={openMintFlow} size={size} {...t16}>{t17}</Button>;
      $[41] = openMintFlow;
      $[42] = overrides.Button;
      $[43] = size;
      $[44] = t15;
      $[45] = t17;
      $[46] = t18;
    } else {
      t18 = $[46];
    }
    let t19;
    if ($[47] !== className || $[48] !== t18) {
      t19 = <span className={className}>{t18}</span>;
      $[47] = className;
      $[48] = t18;
      $[49] = t19;
    } else {
      t19 = $[49];
    }
    let t20;
    if ($[50] !== t13 || $[51] !== t14 || $[52] !== t19) {
      t20 = <Tooltip content={t13} disabled={t14}>{t19}</Tooltip>;
      $[50] = t13;
      $[51] = t14;
      $[52] = t19;
      $[53] = t20;
    } else {
      t20 = $[53];
    }
    let t21;
    if ($[54] !== t11 || $[55] !== t12 || $[56] !== t20) {
      t21 = <Flex className={t11}>{t12}{t20}</Flex>;
      $[54] = t11;
      $[55] = t12;
      $[56] = t20;
      $[57] = t21;
    } else {
      t21 = $[57];
    }
    return t21;
  }
  return null;
}
function _temp3(v_0) {
  return !Number.isNaN(v_0) || "Please enter a valid quantity";
}
function _temp2(selectedToken) {
  return {
    quantity: selectedToken.quantity ?? 1,
    tokenId: selectedToken.tokenId
  };
}
function _temp(state) {
  return [state.status, state.is1155Drop, state.isEligibleForCurrentStage, state.maxMints, state.quantityMinted, state.setQuantityMinted];
}